import { boolean, InferType, lazy, object, string, StringSchema } from 'yup';

import state from '@hero/validators/state';
import { emailYupValidation, phoneYupValidation } from '../../../../../utils/validator';

const enrolmentFormSchema = object()
    .shape({
        first_name: string().trim().required('First name is required.'),
        last_name: string().trim().required('Last name is required.'),
        external_user_id: string().trim().notRequired(),
        is_member: boolean().required('Selection is required'),
        email: emailYupValidation,
        admin_email: string()
            .trim()
            .when('is_member', {
                is: (is_member?: boolean) => !!is_member,
                then: () => emailYupValidation,
                otherwise: (schema) => schema.nullable().notRequired()
            }),
        external_serial: string()
            .trim()
            .when('is_member', {
                is: (is_member?: boolean) => !!is_member,
                then: (schema) => schema.nullable().required('Hero serial number is required'),
                otherwise: (schema) => schema.nullable().notRequired()
            }),
        address_line_1: string().trim().required('Street address is required'),
        address_line_2: string().trim().nullable(),
        city: string().trim().required('City is required'),
        state: lazy((val) =>
            !val ? string().trim().required('State is required') : state
        ) as unknown as StringSchema<string, object>,
        zip_code: string()
            .trim()
            .required('Zip code is required')
            .matches(/^\d{5}$/, 'Invalid zip code'),
        phone: phoneYupValidation
    })
    .defined();

export type EnrolmentFormSchema = InferType<typeof enrolmentFormSchema>;

export { enrolmentFormSchema };
